import ApiManager from './ApiManager';
import JobManager from "../manager/JobManager";
import {
    JOB_STATE_COMPLETE,
    JOB_STATE_DRAFT,
    JOB_STATE_FAILED,
    JOB_STATE_INCOMPLETE,
    JOB_STATE_PROCESSING
} from "../const/job.const";
import {EventBus} from "../events/event.bus";
import {EVENT_JOB_FAIL} from "../events/job.events";
import {useResultPageStore} from "../stores/ResultPageStore";
import {decodeBase64ToImageUrl, encodeImageToBase64} from "../../../../../helper/base64";
import ApiJob from "../model/ApiJob";
import Analytics from "../util/Analytics";

class OriginalImageManager {
    listener = false;

    constructor() {
    }

    async loadOriginalImage(job, files) {

        this.store = useResultPageStore();
        let storeJob = this.store.getJobById(job.id);
        let stageJob = storeJob.getActiveStageJob();

        storeJob.state = JOB_STATE_PROCESSING;

        let thumbnailJob = await ApiManager.create({'operation': 'system thumbnail preview'});

        //this.store.creatorStudio.settings.similiarImageJob.apiJob = thumbnailJob;

        let response = await ApiManager.uploadInputs(thumbnailJob, {}, files);

        let width = response.metadata.image_width;
        let height = response.metadata.image_height;

        let options = {};

        const MAX_HEIGHT = 1400;
        const MAX_WIDTH = 1400;

        function getMediaSize(iw, ih) {
            let
                ratio = 0,
                height = ih,
                width = iw
            ;

            if (iw > MAX_WIDTH && iw > ih)
            {
                height = MAX_WIDTH / (iw / ih /* aspect ratio */);
                width = MAX_WIDTH;
            }
            else if (ih > MAX_HEIGHT && ih > iw)
            {
                width = MAX_HEIGHT / (ih / iw /* aspect ratio */);
                height = MAX_HEIGHT;
            } else if (ih > MAX_HEIGHT && ih === iw) {
                width = MAX_HEIGHT / (ih / iw /* aspect ratio */);
                height = MAX_HEIGHT;
            }

            return {
                width: Math.round(width),
                height: Math.round(height)
            }
        }

        await ApiManager.start(thumbnailJob, {
            target: 'jpg',
            category: 'image',
            options: getMediaSize(width, height),
        }).catch((e) => {
            return;
        });

        await this._waitUntilComplete(thumbnailJob);

        let finalJob =  await ApiManager.get(thumbnailJob);

        stageJob.mainJob = new ApiJob();
        stageJob.mainJob.apiJob = finalJob;

        //this.store.creatorStudio.settings.similiarImageJob.apiJob = finalJob;

        let base64Image = await this._getBase64Image(finalJob.output[0].uri);
        stageJob.mainJob.base64 = base64Image;
        stageJob.layout.sidebar_left = true;
        stageJob.layout.nav_secondary = true;
        stageJob.activeStep = 'draw';

        storeJob.state = JOB_STATE_DRAFT;

        Analytics.send('magic_editor_action', 'load_original_image', stageJob.mainJob)


        //this.store.creatorStudio.settings.similiarImageJob.base64 = base64Image;
    }

    async _getBase64Image(url) {
        return new Promise((resolve, reject) => {
            let uri = url;
            encodeImageToBase64(uri).then((base64String) => {
                resolve(decodeBase64ToImageUrl(base64String));
            });
        });
    }

    async _waitUntilComplete(job, incomplete = 0) {
        return new Promise((resolve, reject) => {

            async function _waitUntilComplete(job, incomplete = 0) {
                let apiJob = await ApiManager.get(job);
                if (null === apiJob) {
                    resolve();

                    return;
                }

                if (apiJob.status.code === JOB_STATE_FAILED) {
                    EventBus.$emit(EVENT_JOB_FAIL, {});

                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_COMPLETE) {
                    resolve();
                    return;
                }

                if (apiJob.status.code === JOB_STATE_INCOMPLETE) {
                    if (incomplete > 60) {
                        job.state = JOB_STATE_FAILED;

                        resolve();
                        return;
                    }

                    setTimeout(() => {
                        _waitUntilComplete(job, ++incomplete);
                    }, 2100);
                    return;
                }

                setTimeout(() => {
                    _waitUntilComplete(job);
                }, 2100);

                return;
            }

            _waitUntilComplete(job, incomplete);
        })
    }

}

export default new OriginalImageManager();